"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTooltip = CustomTooltip;
const react_1 = __importDefault(require("react"));
const toSentenceCase_1 = require("@/utils/toSentenceCase");
const styles_css_1 = require("./styles.css");
const numberFormatter_1 = require("@/utils/numberFormatter");
function CustomTooltip({ active, payload, label, xLabel, yLabel }) {
    if (!active || !payload)
        return null;
    return (react_1.default.createElement("div", { className: styles_css_1.tooltipWrapper },
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", { className: styles_css_1.title }, xLabel),
            react_1.default.createElement("p", null, (0, numberFormatter_1.fixedNumber)(Number(label)))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("p", { className: styles_css_1.title }, yLabel),
            react_1.default.createElement("div", { className: styles_css_1.yAxisWrapper }, payload.map((entry) => {
                var _a, _b;
                const cleanName = String((_a = entry === null || entry === void 0 ? void 0 : entry.name) !== null && _a !== void 0 ? _a : '').replace(/_dataset\d+$/, '');
                return (react_1.default.createElement("p", { key: entry.name, style: { color: entry.color } }, `${(0, toSentenceCase_1.toSentenceCase)(cleanName)}: ${(0, numberFormatter_1.fixedNumber)(Number((_b = entry.value) !== null && _b !== void 0 ? _b : 0))}`));
            })))));
}
